var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2 11.5C2 6.253 6.269 2 11.535 2a9.53 9.53 0 0 1 6.744 2.785c.46.458.942.997 1.395 1.53v-2.23c0-.64.521-1.158 1.163-1.158A1.16 1.16 0 0 1 22 4.085v5.561c0 .64-.52 1.159-1.163 1.159h-5.581a1.16 1.16 0 0 1-1.163-1.159c0-.64.52-1.158 1.163-1.158h3.206c-.578-.71-1.238-1.478-1.828-2.065a7.2 7.2 0 0 0-5.1-2.106c-3.98 0-7.208 3.216-7.208 7.183s3.227 7.183 7.209 7.183a7.21 7.21 0 0 0 6.927-5.187 1.163 1.163 0 0 1 2.235.642A9.534 9.534 0 0 1 11.535 21C6.269 21 2 16.747 2 11.5",
    clipRule: "evenodd"
  })));
};
export default SvgRefresh;